export { default as localeEn } from './localeEn';
export { default as localeEs } from './localeEs';
export { default as localePt } from './localePt';
